import React from "react"
import { Box, Flex } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { Combobox } from "components/Combobox"
import { Guest, GuestStatus, ModalName } from "sharedTypes"
import useModal from "services/useModal"
import DropdownToggle from "../DropdownToggle"

type StatusOption = {
  key: number
  name: string
  color: string
}

type Props = {
  guest: Guest
  updateGuest: (params: {}) => Promise<void>
  disabled: boolean
}

const StatusUpdater = ({
  updateGuest, guest, disabled,
}: Props) => {
  const showModal = useModal()

  const statuses: StatusOption[] = [
    { key: GuestStatus.Unconfirmed, name: "Unconfirmed", color: "status.unconfirmed" },
    { key: GuestStatus.Confirmed, name: "Confirmed", color: "status.confirmed" },
    { key: GuestStatus.Waitlisted, name: "Waitlisted", color: "status.waitlisted" },
    { key: GuestStatus.Declined, name: "Declined", color: "status.declined" },
  ]

  const current = statuses.find(({ key }) => key === guest.status) || statuses[0]

  const onChange = (item: StatusOption | null) => {
    if (!item) return
    showModal(
      ModalName.UpdateGuestStatus,
      { selectedStatusValue: item.key, guest, updateGuest },
    )
  }

  return (
    <Combobox.Root<StatusOption>
      items={statuses}
      getItemKey={(s) => String(s.key)}
      getItemLabel={(s) => s.name}
      value={current}
      onChange={onChange}
    >
      <Combobox.Trigger>
        <Box
          pointerEvents={disabled ? "none" : "auto"}
          opacity={disabled ? 0.6 : 1}
        >
          <DropdownToggle
            icon={<Icon icon="dot" mr={2} color={current.color} />}
            title={current.name}
            disabled={disabled}
          />
        </Box>
      </Combobox.Trigger>
      <Combobox.Content w="280px">
        <Combobox.Header>Confirmation Status</Combobox.Header>
        <Combobox.List<StatusOption> maxH="280px">
          {(item) => (
            <Combobox.Item item={item} fontSize="lg" py={3}>
              <Flex align="center">
                <Icon icon="dot" size={3} mr={4} color={item.color} />
                {item.name}
              </Flex>
            </Combobox.Item>
          )}
        </Combobox.List>
      </Combobox.Content>
    </Combobox.Root>
  )
}

export default StatusUpdater
